import React from 'react';
import { BsCart2 } from 'react-icons/bs';
import { useNavigate } from "react-router-dom";
import useAuth from '../../hooks/useAuth';
import useOrder from '../../hooks/useOrder';
import Button from '../Form/Button';

const AuthorizeUserMobile = () => {
  const { user, signOutUser } = useAuth();
  const navigate = useNavigate();
  const { orders } = useOrder();

  const userName = user?.name || user?.displayName;
  const userPhoto = user?.photoURL;

  return (
    <>
      {userName ? (
        <div className="flex flex-col items-center space-y-4">
          <div
            className="relative flex cursor-pointer"
            onClick={() => navigate('/orders')}
          >
            <span className="bg-paragaia w-6 h-6 rounded-full flex items-center justify-center text-white poppins absolute -right-2 -top-2">
              {Array.isArray(orders)
                ? orders.reduce((sum, item) => sum + (item.quantity || 0), 0)
                : 0}
            </span>
            <BsCart2 className="cursor-pointer w-6 h-6 text-paragaia" />
          </div>

          <img
            src={userPhoto || "https://res.cloudinary.com/dfqozoox8/image/upload/v1752454345/team_v65npd.png"}
            alt={userName || "Default Avatar"}
            className="w-12 h-12 rounded-full"
          />

          <p className="text-paragaia poppins text-sm">{userName}</p>

          <Button
            className="bg-paragaia text-white w-full py-3 rounded-lg poppins hover:bg-paragaiaLight transition"
            onClick={() => signOutUser('[NavbarMobile] Manual logout')}
            text="Déconnexion"
          />
        </div>
      ) : (
        <div className="flex flex-col space-y-4 items-center justify-center">
          <button
            className="poppins text-paragaia text-lg"
            onClick={() => navigate('/signin')}
          >
            Connexion
          </button>
          <button
            className="bg-paragaia text-white px-6 py-3 rounded-full poppins hover:bg-paragaiaLight transition"
            onClick={() => navigate('/signup')}
          >
            Créer un compte
          </button>
        </div>
      )}
    </>
  );
};

export default AuthorizeUserMobile;
